import { Component, inject, Input } from '@angular/core';
import { CookieService, CookieOptions } from 'ngx-cookie-service';
import { GoogleAnalyticsService } from '@shared-services/google-analytics.service';

declare function updateCrossDomainLinks(...args: any[]): void;

@Component({
    selector: 'fourd-cookie-notification',
    imports: [],
    templateUrl: './cookie-notification.component.html',
    styleUrl: './cookie-notification.component.css',
    providers: [CookieService]
})
export class CookieNotificationComponent {
  @Input() brand: string;

  protected googleAnalyticsService = inject(GoogleAnalyticsService);

  readonly cookieKey: string = 'cc';
  readonly cookieValueConsent: string = 'c1';
  readonly cookieValueConsentAndLog: string = this.cookieValueConsent + 'l1';
  readonly cookieExpiresDays: number = 365 / 2; // Use 6 months
  readonly cookieOptions: CookieOptions = { expires: this.cookieExpiresDays, path: '/', secure: true, sameSite: 'None' };

  show: boolean = false;

  constructor(private cookieService: CookieService) {
    let cookieValue = this.cookieService.get(this.cookieKey);
    if (!cookieValue) {
      this.show = true;
    } else {
      this.show = false;
    }    
  }

  close(): void {
    this.show = false;
    this.googleAnalyticsService?.emitConsentGranted();
    this.cookieService.set(this.cookieKey, this.cookieValueConsent, this.cookieOptions);
    this.googleAnalyticsService?.logCookieDataConsent(true, (result) => {
      if (result) {
        this.cookieService.set(this.cookieKey, this.cookieValueConsentAndLog, this.cookieOptions);
      }
    });
    this.googleAnalyticsService?.checkForClientId();
    if (this.updateCrossDomainLinksDefined()) {
      updateCrossDomainLinks(this.cookieValueConsent);
    }
  }

  private updateCrossDomainLinksDefined(): boolean {
    return typeof updateCrossDomainLinks == 'function';
  }
}
